import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import { VIEW, VALUE, UNLIMITED } from "const"
import {
    StoreType,
    DriveOnSelectFile,
    DriveOnSelectFiles,
    DriveOnSelectVersion,

    setDriveBaseRoute,
    setDriveOnSelectFile,
    setDriveOnSelectFiles,
    setDriveOnSelectVersion,
} from "client/store"
import {
    projectsRoute,
    projectBaseRoute,
    driveRoute,
} from "client/parts/routes"
import { Switch, Route } from "client/components"

import AccessDenied from "client/parts/accessDenied"
import List from "./list"

/*
=== IMPORTANT ===
When "onSelect" function is transfered to drive module and drive is opened in a modal window:
--- all "replaceHistoryState" functions are BLOCKED
--- all links have href="/#" (except the links for file downloading)
*/

export interface DriveProps {
    onSelectFile?: DriveOnSelectFile
    onSelectFiles?: DriveOnSelectFiles
    onSelectVersion?: DriveOnSelectVersion
}

const Drive = ({
    onSelectFile = null,
    onSelectFiles = null,
    onSelectVersion = null,
}: DriveProps) => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const packageSettings = useSelector((state: StoreType) => state.system.packageSettings)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const dispatch = useDispatch()

    const { driveSpace, driveSpaceValue } = packageSettings

    let access = false
    if (userData.accountId !== 1 && driveSpace === VALUE && driveSpaceValue > 0) access = true
    if (userData.accountId !== 1 && driveSpace === UNLIMITED) access = true
    if (userData.accountId === 1) access = true

    const baseRouteMask = project.id ? `${projectBaseRoute}${driveRoute}` : driveRoute
    const baseRoute = project.id ? `${projectsRoute}/${VIEW}/${project.id}${driveRoute}` : driveRoute

    useEffect(() => {
        dispatch(setDriveOnSelectFile(onSelectFile))
        dispatch(setDriveOnSelectFiles(onSelectFiles))
        dispatch(setDriveOnSelectVersion(onSelectVersion))

        dispatch(setDriveBaseRoute(baseRoute))
    }, [])

    if (!access) return <AccessDenied />
    if (onSelectFile || onSelectFiles || onSelectVersion) return <List />
    return (
        <Switch>
            <Route
                path={`${baseRouteMask}/:path*`}
                component={List}
            />
            <Route
                path={baseRouteMask}
                component={List}
            />
        </Switch>
    )
}
export default Drive
